import { useState, useEffect } from 'react';
import { getUser } from '../Utility/getUser';
import Footer from '../Footer/Footer';

const Dashboard = () => {
  const [orders, setOrders] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedInUser = getUser();
    if (loggedInUser) {
      setUser(loggedInUser);
      fetchOrders(loggedInUser.users_id);
    }
  }, []);

  const fetchOrders = async (userId) => {
    try {
      const response = await fetch(`https://panel.masit.net/api/view.php?table=user_orders&users_id=${userId}`);
      const data = await response.json();
      if (Array.isArray(data)) {
        setOrders(data);
      } else {
        console.error('Unexpected response format:', data);
        setOrders([]);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      setOrders([]);
    }
  };

  if (!user) {
    return <p>Please log in to view your dashboard.</p>;
  }

return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
        <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">My Orders</h2>
            {orders.length === 0 ? (
                <p className="text-gray-700 dark:text-gray-300">You have no orders.</p>
            ) : (
                <div className="space-y-8">
                    {orders.map((order) => (
                        <div key={order.order_id} className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Order #{order.order_id}</h3>
                            <p className="text-gray-500 dark:text-gray-300 mb-4">Order Date: {order.order_date}</p>
                            <div className="space-y-4">
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center">
                                        <img src={order.items_image} alt={order.items_name} className="w-16 h-16 object-cover rounded-lg" />
                                        <div className="ml-4">
                                            <h4 className="text-lg font-medium text-gray-900 dark:text-white">{order.items_name}</h4>
                                            <p className="text-gray-500 dark:text-gray-300">Quantity: {order.quantity}</p>
                                        </div>
                                    </div>
                                    <p className="text-lg font-medium text-gray-900 dark:text-white">€{order.items_price}</p>
                                </div>
                            </div>
                            <div className="mt-6 flex justify-between items-center">
                                <p className="text-lg font-medium text-gray-900 dark:text-white">Total: €{order.items_price * order.quantity}</p>
                                <p className={`text-lg font-medium ${
                                    order.status === 'Shipped' ? 'text-green-500' : 
                                    order.status === 'Pending' ? 'text-yellow-400' : 
                                    order.status === 'In Process' ? 'text-orange-300' : 'text-red-500'
                                }`}>
                                    {order.status}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
        <Footer />
    </div>
);
};

export default Dashboard;